import { makeStyles } from '@material-ui/core';

// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const iconStyle = makeStyles((theme: any) => ({
  icon: {
    color: theme?.configColors?.primaryText || 'white',
    '& #calculator-Buttons': {
      fill: 'currentColor',
    },
    '& #calculator-Border': {
      stroke: 'currentColor',
    },
  },
}));
